import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Loader from '../common/Loader/Loader';

const GoogleCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigateRef = useRef(false);

  useEffect(() => {
    const handleGoogleCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');

      if (code) {
        try {
          const response = await fetch('/api/v1/auth/google/callback', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code, state }),
          });

          const data = await response.json();

          if (data.success) {
            localStorage.setItem('accessToken', data.data.accessToken);
            localStorage.setItem('refreshToken', data.data.refreshToken);
            if (!navigateRef.current) {
              navigateRef.current = true;
              navigate('/dashboard');
            }
          } else {
            if (!navigateRef.current) {
              navigateRef.current = true;
              navigate('/', {
                state: { error: data.message || 'Google login failed' },
              });
            }
          }
        } catch (error) {
          if (!navigateRef.current) {
            navigateRef.current = true;
            navigate('/', {
              state: { error: 'Failed to complete Google login' },
            });
          }
        }
      } else {
        if (!navigateRef.current) {
          navigateRef.current = true;
          navigate('/', {
            state: { error: 'No authorization code received' },
          });
        }
      }
    };

    handleGoogleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="google-callback">
      <Loader fullScreen />
      <p>Completing Google sign-in...</p>
    </div>
  );
};

export default GoogleCallback;
